import { colors } from "#app/theme/v1/colors";

export const LAYOUT_COLORS = {
  USED_ITEM: colors.gray[1],
  UNUSED_ITEM: colors.gray[4],
  TEXT_ON_USED: colors.gray[7],
  TEXT_ON_UNUSED: colors.gray[9],
  CANVAS_BACKGROUND: colors.dark[9],
  BORDER: "black",
} as const;
